import { inject } from '@angular/core';
import { ApiClientService } from './api-client.service';
import { API_BASE_URL } from '../tokens/api-base-url.token';

export abstract class BaseService {
  protected readonly serverUrl = BaseService.normalize(inject(API_BASE_URL));

  protected constructor(protected readonly api: ApiClientService) {}

  protected buildUrl(path: string): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${this.serverUrl}${normalizedPath}`;
  }

  /**
   * Some v2 application endpoints are mounted at the gateway root rather than
   * under the `/deeds` prefix that `serverUrl` carries (e.g.
   * `https://dlap-gateway.dev.dokuma.co.zw/api/v2/applications/...` vs the
   * usual `.../deeds/public/...`). Use this instead of buildUrl() for those.
   */
  protected buildGatewayUrl(path: string): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${new URL(this.serverUrl).origin}${normalizedPath}`;
  }

  /**
   * Some deeds-portal features (file recovery, farms) are actually served by
   * the `/farms` module at the gateway root rather than the `/deeds` prefix
   * that `serverUrl` carries. Use this instead of buildUrl() for those.
   */
  protected buildFarmsUrl(path: string): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${new URL(this.serverUrl).origin}/farms${normalizedPath}`;
  }

  private static normalize(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }
}
